import React, {type JSX} from 'react';
import {Button, BUTTON_VARIANT, Text, ALIGN, SPACE} from '@lookiero/aurora';
import {GoogleIcon} from '../GoogleIcon';

interface Props {
  onButtonPressed: () => void;
  label: string;
  testID?: string;
  busy: boolean;
}

export const GoogleButton = ({onButtonPressed, label, testID, busy}: Props): JSX.Element => (
  <Button onPress={onButtonPressed} testID={testID} busy={busy} variant={BUTTON_VARIANT.SECONDARY}>
    <GoogleIcon />
    <Text align={ALIGN.CENTER} marginLeft={SPACE.SPACE_2} action>
      {label}
    </Text>
  </Button>
);
